export default __webpack_public_path__ + "static/media/T735_RoHS.18b3fa63.pdf";